import "./Card.scss";

const Card = (props) => {
  const state = props.state ? props.state : "default";
  const size = props.size ? props.size : "big";
  const button = props.button ? props.button : "";

  return (
    <>
      <div
        className={`Card Card_state_${state} Card_size_${size} ${props.className}`}
        ref={props.cardRef}
      >
        {props.children}
        {button && (
          <button
            type="submit"
            className="Button Card__button"
            onClick={props.buttonOnClick}
          >
            {button}
          </button>
        )}
      </div>
      {button && <div className="Card__button-separator"></div>}
    </>
  );
};

export default Card;
